<template>
  <div>
    <el-form class="toolbar" :inline="true" @keyup.enter.native="search">
      <el-form-item label="通知单号"><el-input v-model="query.ecnCode" size="small" clearable style="width:140px" /></el-form-item>
      <el-form-item label="审核">
        <el-select v-model="query.approveStatus" clearable size="small" style="width:100px">
          <el-option label="未审" value="0" /><el-option label="已审" value="2" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('plm:plmEcn:list')" type="primary" size="small" @click="search">查询</el-button>
        <el-button v-if="isAuth('plm:plmEcn:save')" type="primary" size="small" @click="open()">新增</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="pageList" border v-loading="loading" :header-cell-style="headStyle">
      <el-table-column type="index" label="序号" width="60" header-align="center" align="center" />
      <el-table-column prop="ecnCode" label="通知单号" min-width="130" header-align="center" align="left">
        <template slot-scope="scope">
          <a v-if="isAuth('plm:plmEcn:info')" class="code-link" @click="open(scope.row, true)">{{ scope.row.ecnCode }}</a>
          <span v-else>{{ scope.row.ecnCode }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="title" label="标题" min-width="140" header-align="center" align="left" show-overflow-tooltip />
      <el-table-column prop="materialCode" label="物料" min-width="110" header-align="center" align="left" />
      <el-table-column prop="effectMode" label="生效方式" width="90" header-align="center" align="center">
        <template slot-scope="scope">{{ effectLabel(scope.row.effectMode) }}</template>
      </el-table-column>
      <el-table-column prop="approveStatus" label="审核" width="80" header-align="center" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.approveStatus === '2' ? 'success' : 'info'" size="mini">{{ scope.row.approveStatus === '2' ? '已审' : '未审' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="implementStatus" label="实施" width="80" header-align="center" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.implementStatus === '1' ? 'success' : 'info'" size="mini">{{ scope.row.implementStatus === '1' ? '已实施' : '未实施' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="260" header-align="center" align="center">
        <template slot-scope="scope">
          <el-button v-if="(isAuth('plm:plmEcn:update') || isAuth('plm:plmEcn:save')) && scope.row.approveStatus !== '2'" type="text" size="small" @click="open(scope.row, false)">修改</el-button>
          <el-button v-if="isAuth('plm:plmEcn:approve') && scope.row.approveStatus !== '2'" type="text" size="small" @click="approve(scope.row, true)">审核实施</el-button>
          <el-button v-if="isAuth('plm:plmEcn:unapprove') && scope.row.approveStatus === '2' && scope.row.implementStatus !== '1'" type="text" size="small" @click="approve(scope.row, false)">弃审</el-button>
          <el-button v-if="(isAuth('plm:plmEcn:delete') || isAuth('plm:plmEcn:save')) && scope.row.approveStatus !== '2'" type="text" size="small" @click="remove(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="list-pagination" background :current-page="pageIndex" :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="total"
      layout="total, sizes, prev, pager, next, jumper" @size-change="s => { pageSize = s; pageIndex = 1 }" @current-change="p => { pageIndex = p }" />

    <el-dialog :title="dialogTitle" :visible.sync="visible" width="min(920px, calc(100vw - 24px))" :close-on-click-modal="false">
      <el-form ref="dataForm" v-loading="infoLoading" :model="form" :rules="readonly ? {} : rules" label-width="110px" :disabled="readonly || infoLoading">
        <el-form-item label="通知单号" prop="ecnCode"><el-input v-model="form.ecnCode" :disabled="!!form.ecnId" /></el-form-item>
        <el-form-item label="标题" prop="title"><el-input v-model="form.title" /></el-form-item>
        <el-form-item label="关联物料">
          <el-input v-model="form.materialCode" readonly placeholder="点击选择">
            <el-button v-if="!readonly" slot="append" @click="materialSelectorVisible = true">选择</el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="变更级别">
          <el-select v-model="form.changeLevel" style="width:100%">
            <el-option label="重大" value="major" /><el-option label="一般" value="minor" />
          </el-select>
        </el-form-item>
        <el-form-item label="生效方式">
          <el-select v-model="form.effectMode" style="width:100%">
            <el-option label="立即" value="immediate" /><el-option label="指定日期" value="date" /><el-option label="随工单" value="order" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="form.effectMode === 'date'" label="生效日期">
          <el-date-picker v-model="form.effectiveDate" type="date" value-format="yyyy-MM-dd" style="width:100%" />
        </el-form-item>
        <el-form-item label="变更明细">
          <el-button v-if="!readonly" size="mini" type="primary" plain @click="addLine">新增行</el-button>
          <el-table :data="form.lines" border size="small" style="margin-top:8px" :header-cell-style="headStyle">
            <el-table-column type="index" label="序号" width="50" header-align="center" align="center" />
            <el-table-column label="类型" width="110">
              <template slot-scope="s">
                <el-select v-model="s.row.objectType" size="mini" :disabled="readonly">
                  <el-option label="BOM" value="bom" />
                  <el-option label="物料属性" value="material_attr" />
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="物料" min-width="130">
              <template slot-scope="s">
                <el-input :value="s.row.materialCode || s.row.materialId" readonly size="mini">
                  <el-button v-if="!readonly" slot="append" @click="openLineMaterialPicker(s.$index)">选</el-button>
                </el-input>
              </template>
            </el-table-column>
            <el-table-column v-if="hasBomLine" key="bomType" column-key="bomType" label="BOM" width="90">
              <template slot-scope="s">
                <el-select v-if="s.row.objectType === 'bom'" v-model="s.row.bomType" size="mini" :disabled="readonly">
                  <el-option label="MBOM" value="mbom" /><el-option label="EBOM" value="ebom" />
                </el-select>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column v-if="hasBomLine" key="versionBefore" column-key="versionBefore" label="原版本" width="90">
              <template slot-scope="s">
                <el-input v-if="s.row.objectType === 'bom'" v-model="s.row.versionBefore" size="mini" :disabled="readonly" />
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column v-if="hasBomLine" key="changeAction" column-key="changeAction" label="动作" width="90">
              <template slot-scope="s">
                <el-select v-if="s.row.objectType === 'bom'" v-model="s.row.changeAction" size="mini" :disabled="readonly">
                  <el-option label="修改" value="change" /><el-option label="新增" value="add" /><el-option label="删除" value="delete" />
                </el-select>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column v-if="hasBomLine" key="childMaterial" column-key="childMaterial" label="子件" min-width="120">
              <template slot-scope="s">
                <el-input v-if="s.row.objectType === 'bom'" :value="s.row.childMaterialCode || s.row.childMaterialId" readonly size="mini">
                  <el-button v-if="!readonly" slot="append" @click="openChildMaterialPicker(s.$index)">选</el-button>
                </el-input>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column v-if="hasBomLine" key="quantityAfter" column-key="quantityAfter" label="后用量" width="80">
              <template slot-scope="s">
                <el-input v-if="s.row.objectType === 'bom'" v-model="s.row.quantityAfter" size="mini" :disabled="readonly" />
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column v-if="hasAttrLine" key="attrKey" column-key="attrKey" label="属性键" width="100">
              <template slot-scope="s">
                <el-select v-if="s.row.objectType === 'material_attr'" v-model="s.row.attrKey" size="mini" :disabled="readonly">
                  <el-option label="图号" value="drawing_no" /><el-option label="规格" value="specs" />
                </el-select>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column v-if="hasAttrLine" key="attrValueAfter" column-key="attrValueAfter" label="属性值" min-width="100">
              <template slot-scope="s">
                <el-input v-if="s.row.objectType === 'material_attr'" v-model="s.row.attrValueAfter" size="mini" :disabled="readonly" />
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column v-if="!readonly" key="lineActions" column-key="lineActions" label="操作" width="60" align="center">
              <template slot-scope="s"><el-button type="text" size="mini" @click="form.lines.splice(s.$index, 1)">删</el-button></template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="visible = false">关闭</el-button>
        <el-button v-if="!readonly" type="primary" :disabled="infoLoading" @click="save">保存</el-button>
      </span>
    </el-dialog>
    <material-selector :visible.sync="materialSelectorVisible" :multiple="false" @select="onMaterialSelect" />
    <material-selector :visible.sync="lineMaterialSelectorVisible" :multiple="false" @select="onLineMaterialSelect" />
    <material-selector :visible.sync="childMaterialSelectorVisible" :multiple="false" @select="onChildMaterialSelect" />
  </div>
</template>

<script>
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'
import MaterialSelector from '../../components/MaterialSelector.vue'

export default {
  name: 'PlmEcn',
  components: { MaterialSelector },
  data() {
    return {
      query: { ecnCode: '', approveStatus: '' },
      list: [], pageIndex: 1, pageSize: 10, loading: false, visible: false, readonly: false, infoLoading: false, infoRequestId: 0,
      materialSelectorVisible: false, lineMaterialSelectorVisible: false, childMaterialSelectorVisible: false,
      linePickIndex: -1, childPickIndex: -1, permCodes: [], form: {},
      headStyle: { background: '#f5f7fa', color: '#606266', textAlign: 'center' },
      rules: {
        ecnCode: [{ required: true, message: '通知单号不能为空', trigger: 'blur' }],
        title: [{ required: true, message: '标题不能为空', trigger: 'blur' }]
      }
    }
  },
  computed: {
    dialogTitle() {
      if (this.readonly) return '查看变更通知'
      return this.form.ecnId ? '修改变更通知' : '新增变更通知'
    },
    filtered() {
      return this.list.filter(row => this.has(row.ecnCode, this.query.ecnCode) && (!this.query.approveStatus || row.approveStatus === this.query.approveStatus))
    },
    total() { return this.filtered.length },
    pageList() { return this.filtered.slice((this.pageIndex - 1) * this.pageSize, this.pageIndex * this.pageSize) },
    hasBomLine() { return (this.form.lines || []).some(l => l.objectType === 'bom') },
    hasAttrLine() { return (this.form.lines || []).some(l => l.objectType === 'material_attr') }
  },
  created() { this.loadPerms(); this.load() },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      if (['TENANT_ADMIN', 'PLATFORM_ADMIN'].indexOf(String(user.roleCode || '')) >= 0 || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    loadPerms() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },
    has(value, keyword) {
      const text = String(keyword || '').trim().toLowerCase()
      if (!text) return true
      return String(value || '').toLowerCase().indexOf(text) >= 0
    },
    effectLabel(v) {
      const map = { immediate: '立即', date: '指定日期', order: '随工单' }
      return map[v] || v || '立即'
    },
    search() { this.pageIndex = 1; this.load() },
    load() {
      this.loading = true
      request.get('/plm/ecn/list').then(res => { this.list = res.data || [] }).catch(() => { this.list = [] }).finally(() => { this.loading = false })
    },
    blankLine() {
      return {
        objectType: 'bom', materialId: '', materialCode: '', bomType: 'mbom',
        versionBefore: '', versionAfter: '', changeAction: 'change',
        childMaterialId: '', childMaterialCode: '', parentId: '', quantityAfter: 1,
        attrKey: 'drawing_no', attrValueAfter: ''
      }
    },
    addLine() {
      const line = this.blankLine()
      if (this.form.materialId) {
        line.materialId = this.form.materialId
        line.materialCode = this.form.materialCode
      }
      this.form.lines.push(line)
    },
    onMaterialSelect(row) {
      this.form.materialId = row.materialId
      this.form.materialCode = row.materialCode
      this.materialSelectorVisible = false
    },
    openLineMaterialPicker(index) {
      this.linePickIndex = index
      this.lineMaterialSelectorVisible = true
    },
    onLineMaterialSelect(row) {
      if (this.linePickIndex < 0 || !this.form.lines[this.linePickIndex]) return
      this.$set(this.form.lines[this.linePickIndex], 'materialId', row.materialId)
      this.$set(this.form.lines[this.linePickIndex], 'materialCode', row.materialCode)
      this.lineMaterialSelectorVisible = false
    },
    openChildMaterialPicker(index) {
      this.childPickIndex = index
      this.childMaterialSelectorVisible = true
    },
    onChildMaterialSelect(row) {
      if (this.childPickIndex < 0 || !this.form.lines[this.childPickIndex]) return
      this.$set(this.form.lines[this.childPickIndex], 'childMaterialId', row.materialId)
      this.$set(this.form.lines[this.childPickIndex], 'childMaterialCode', row.materialCode)
      this.childMaterialSelectorVisible = false
    },
    open(row, readonly) {
      this.readonly = !!readonly
      const requestId = ++this.infoRequestId
      const blank = () => ({
        ecnId: '', ecnCode: '', title: '', materialId: '', materialCode: '',
        changeLevel: 'major', effectMode: 'immediate', effectiveDate: '',
        approveStatus: '0', implementStatus: '0', lines: []
      })
      if (!row || !row.ecnId) {
        this.infoLoading = false
        this.form = blank()
        this.visible = true
        this.$nextTick(() => { this.$refs.dataForm && this.$refs.dataForm.clearValidate() })
        return
      }
      this.form = Object.assign(blank(), row, { lines: row.lines || [] })
      this.infoLoading = true
      this.visible = true
      request.get('/plm/ecn/info', { params: { id: row.ecnId } }).then(res => {
        if (requestId !== this.infoRequestId || !this.visible || this.form.ecnId !== row.ecnId) return
        const data = res.data || row
        this.form = Object.assign(blank(), data, { lines: data.lines || [] })
        this.$nextTick(() => { this.$refs.dataForm && this.$refs.dataForm.clearValidate() })
      }).catch(() => {
        if (requestId !== this.infoRequestId || !this.visible || this.form.ecnId !== row.ecnId) return
        this.visible = false
        this.$message.error('变更通知详情加载失败，请重试')
      }).finally(() => { if (requestId === this.infoRequestId) this.infoLoading = false })
    },
    save() {
      if (this.infoLoading) return
      this.$refs.dataForm.validate(valid => {
        if (!valid) return
        request.post('/plm/ecn/save', {
          ecnId: this.form.ecnId, ecnCode: this.form.ecnCode, title: this.form.title,
          materialId: this.form.materialId, changeLevel: this.form.changeLevel,
          effectMode: this.form.effectMode, effectiveDate: this.form.effectiveDate,
          lines: (this.form.lines || []).map(l => ({
            objectType: l.objectType,
            materialId: l.materialId,
            bomType: l.bomType,
            versionBefore: l.versionBefore,
            versionAfter: l.versionAfter,
            changeAction: l.changeAction,
            childMaterialId: l.childMaterialId,
            parentId: l.parentId || '',
            quantityAfter: l.quantityAfter,
            attrKey: l.attrKey,
            attrValueAfter: l.attrValueAfter
          }))
        }).then(() => { this.$message.success('保存成功'); this.visible = false; this.load() }).catch(() => {})
      })
    },
    approve(row, yes) {
      const path = yes ? '/plm/ecn/approve' : '/plm/ecn/unapprove'
      const tip = yes ? '审核并实施成功' : '弃审成功'
      request.post(path, { id: row.ecnId }).then(() => { this.$message.success(tip); this.load() }).catch(() => {})
    },
    remove(row) {
      if (!row || !row.ecnId) return
      if (String(row.approveStatus) === '2') {
        this.$message.warning('已审核的变更通知不可删除，请先弃审')
        return
      }
      this.$confirm('确定删除该变更通知?', '提示', { type: 'warning' }).then(() => {
        request.post('/plm/ecn/delete', { id: row.ecnId }).then(() => {
          this.$message.success('删除成功'); this.visible = false; this.load()
        }).catch(() => {})
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.list-pagination { margin-top: 12px; text-align: right; }
.toolbar >>> .el-form-item { margin-bottom: 8px; }
.code-link { color: #348adb; cursor: pointer; }
</style>
